export default "__VITE_ASSET__oxQ9fOs5__"